import { render } from "./RestyleSelect.vue?vue&type=template&id=33299ccc&scoped=true"
import script from "./RestyleSelect.vue?vue&type=script&lang=js"
export * from "./RestyleSelect.vue?vue&type=script&lang=js"

import "./RestyleSelect.vue?vue&type=style&index=0&id=33299ccc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33299ccc"]])

export default __exports__